export const PROCEED_TO_NEXT_FORM_STEP = "PROCEED_TO_NEXT_FORM_STEP";
export const GO_BACK = "GO_BACK";
export const SET_DIVERSITY_FORM_LOADING = "SET_DIVERSITY_FORM_LOADING";
export const SET_PAGE_TRANSITION_DIRECTION = "SET_PAGE_TRANSITION_DIRECTION";
export const SUBMIT_DIVERSITY_FORM = "SUBMIT_DIVERSITY_FORM";
export const SUBMIT_DIVERSITY_FORM_ERROR = "SUBMIT_DIVERSITY_FORM_ERROR";

interface ProceedToNextFormStepAction {
  type: typeof PROCEED_TO_NEXT_FORM_STEP;
  payload?;
}

interface GoBackAction {
  type: typeof GO_BACK;
  payload?;
}

interface SetDiversityFormLoadingAction {
  type: typeof SET_DIVERSITY_FORM_LOADING;
  payload?;
}

interface SetPageTransitionDirectionAction {
  type: typeof SET_PAGE_TRANSITION_DIRECTION;
  payload: { direction: string };
}

export type FormDataPayload = {
  gender: string;
  pronouns: string;
  age: string;
  ethnicGroup: string;
  ethnicSubgroup: string;
  disability: string;
  orientation: string;
  religion: string;
  caringResponsibilities: string;
  caringResponsibilitiesType: string;
};

interface SubmitDiversityForm {
  type: typeof SUBMIT_DIVERSITY_FORM;
  payload?: FormDataPayload;
}

interface SubmitDiversityFormError {
  type: typeof SUBMIT_DIVERSITY_FORM_ERROR;
  payload?;
}

export type DiversityFormActions =
  | ProceedToNextFormStepAction
  | GoBackAction
  | SetDiversityFormLoadingAction
  | SetPageTransitionDirectionAction
  | SubmitDiversityForm
  | SubmitDiversityFormError;
